<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="room-type content-wrapper">
      <div class="page-header">{{ $t('newRoomType') }}</div>
      <div style="margin-bottom: 40px; margin-left: 5px;">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ name: 'HotelRoomTypeList' }">{{ $t('roomTypeList') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('newRoomType') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" label-width="150px" style="width: 500px">
        <el-form-item :label="$t('code')" :required="true">
          <el-input class="text-uppercase" v-model="roomType.code"></el-input>
        </el-form-item>
        <el-form-item :label="$t('name')" :required="true">
          <el-input v-model="roomType.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('status')">
          <el-radio-group v-model="roomType.isEnable" fill="#ff0000" >
            <el-radio :label="STATUS.ENABLE">{{ $t('STATUS.ENABLE') }}</el-radio>
            <el-radio :label="STATUS.DISABLE">{{ $t('STATUS.DISABLE') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="onCreateRoomTypeButtonClick">{{ $t('create') }}</el-button>
          <el-button type="default" @click="onCancelButtonClick">{{ $t('cancel') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </ContentContainer>
</template>

<script>
import { STATUS } from '@/configs/constant'
import i18nMessages from '@/translations/Hotel/ManageHotel/RoomType/Add.i18n'
import HotelRoomTypeApi from '@/api/hotel/room-type-api'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import ContentContainer from '@/components/ContentContainerComponent.vue'
import LocalStorageFactory from '@/factories/local-storage-factory'
import { getHotelIndexRoute } from '@/services/hotel-service'
import { mapState } from 'vuex'

export default {
  name: 'HotelRoomTypeAdd',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { ContentContainer },
  i18n: { messages: i18nMessages },
  created: async function () {
    this.isLoading = true

    if (this.activeHotelId === undefined || this.activeHotelId === '') {
      const companyDetail = LocalStorageFactory.getCompanyDetail()
      const routeName = await getHotelIndexRoute(companyDetail, this.$store)

      return this.$router.push({
        name: routeName
      })
    }

    this.isLoading = false
  },
  computed: {
    ...mapState({
      activeHotelId: state => state.general.activeHotelId
    })
  },
  data () {
    return {
      isLoading: false,
      STATUS,
      roomType: {
        code: '',
        name: '',
        isEnable: STATUS.ENABLE
      }
    }
  },
  methods: {
    onCreateRoomTypeButtonClick: async function () {
      try {
        this.startLoading()

        this.roomType.code = this.roomType.code.toUpperCase()
        await HotelRoomTypeApi.create(this.activeHotelId, this.roomType)
        this.$router.push({
          name: 'HotelRoomTypeList'
        })

        const title = this.$t('createRoomTypeSuccessTitle')
        const message = this.$t('createRoomTypeSuccessMessage')

        this.showNotificationSuccess(title, message)
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    },
    onCancelButtonClick: function () {
      this.$router.push({
        name: 'HotelRoomTypeList'
      })
    }
  }
}
</script>

<style>
  .el-form > div {
    text-align: left;
  }
</style>
